import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/signals/list'
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error'
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* process(action) {
  try {
    const { page, rowsPerPage, query } = action.payload; // Extract page and rowsPerPage from the action

    const queryString = query ? `&${query}` : '';
    const response = yield call(
        axios.get,
        `${config.API_URL}/signal?page=${page}&per_page=${rowsPerPage}${queryString}`,
        { headers: getLocalUser() }
      );
    yield put(fetchSuccess(response.data.data.data));

  } catch (error) {
    yield put(Error(error))
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, process);
}
